import React from 'react';
import styled from 'styled-components';
import { Carousel, Skeleton, SkeletonText, spacingHelper } from '@construct-kit/core';

const Title = styled(SkeletonText)`
  margin: 0 0 ${spacingHelper('medium')};
  height: 28px;
  ${({ theme }) => theme.layoutBreakpoints.large} {
    height: 36px;
  }
`;

const ListingCard = styled.div`
  display: inline-block;
  width: 240px;
`;

const Address = styled(SkeletonText)`
  margin: ${spacingHelper('twoExtraSmall')} 0;
`;

const Price = styled(SkeletonText)`
  margin: ${spacingHelper('twoExtraSmall')} 0;
`;

const ElitePlusListingCard: React.FC = () => (
  <ListingCard data-testid="skeleton-listing-card">
    <Skeleton>
      <img alt="" height="196px" width="240px" />
    </Skeleton>
    <Address height="body01" numOfLines={2} gap="0" />
    <Price height="body02" />
    <SkeletonText height="body02" />
  </ListingCard>
);

const ElitePlusCarouselSkeleton: React.FunctionComponent = () => (
  <div>
    <Title height="title01" />
    <Carousel insideGap="medium" outsideGap="0" showScrollButtons="auto">
      {Array.from({ length: 5 }, (_, index) => (
        <ElitePlusListingCard key={`elitePlusListingCard-${index}`} />
      ))}
    </Carousel>
  </div>
);

export default ElitePlusCarouselSkeleton;
